import { render, staticRenderFns } from "./PreviewConsultationModalV2.vue?vue&type=template&id=cb6b551a"
import script from "./PreviewConsultationModalV2.vue?vue&type=script&lang=js"
export * from "./PreviewConsultationModalV2.vue?vue&type=script&lang=js"
import style0 from "./PreviewConsultationModalV2.vue?vue&type=style&index=0&id=cb6b551a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports